import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '../hooks/useTheme';
import { Colors, Spacing, Radius, FontSize, FontWeight } from '../theme/tokens';

type BadgeType = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface BadgeProps {
  text: string;
  type?: BadgeType;
}

const BG: Record<BadgeType, string> = {
  success: 'rgba(16,185,129,0.12)',
  warning: 'rgba(245,158,11,0.12)',
  error:   'rgba(239,68,68,0.12)',
  info:    'rgba(64,112,244,0.12)',
  neutral: 'transparent', // overridden at render time with theme pill
};

export const Badge: React.FC<BadgeProps> = ({ text, type = 'info' }) => {
  const { colors } = useTheme();

  const textColor =
    type === 'neutral' ? colors.subtext : colors.brand;

  const bgColor = colors.pill;

  return (
    <View style={[styles.badge, { backgroundColor: bgColor }]}>
      <Text style={[styles.label, { color: textColor }]}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: Spacing.sm,
    paddingVertical:   Spacing.xs,
    borderRadius:      Radius.sm,
    alignSelf:         'flex-start',
  },
  label: {
    fontSize:      FontSize.xs,
    fontWeight:    FontWeight.bold,
    textTransform: 'uppercase',
  },
});
